import { GlobalAppState } from '@model/state';

export const getIsServer = (state: GlobalAppState) => state.app.uiState.isServer;
export const getIsMobile = (state: GlobalAppState) => state.app.uiState.isMobile;
export const getIsDesktop = (state: GlobalAppState) => state.app.uiState.isDesktop;
export const getShowSearch = (state: GlobalAppState) => state.app.uiState.showSearch;
